import { render, staticRenderFns } from "./sessionModal.vue?vue&type=template&id=636d243a&scoped=true&"
import script from "./sessionModal.vue?vue&type=script&lang=js&"
export * from "./sessionModal.vue?vue&type=script&lang=js&"
import style0 from "./sessionModal.vue?vue&type=style&index=0&id=636d243a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636d243a",
  null
  
)

export default component.exports